
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#171C26","fill-rule":"evenodd","d":"M13.387 12l4.283 4.283a1.971 1.971 0 010 2.775L12 13.388l-4.168 4.168a1.962 1.962 0 01-2.775 0L10.613 12 6.33 7.717a1.962 1.962 0 010-2.775l5.67 5.67 4.175-4.174a1.962 1.962 0 012.774 0L13.387 12z","clip-rule":"evenodd"}})])
          )
        }
      }
    